import {
    DESCRIPTION_DETECTNAME,
    DESCRIPTION_SQL_DSNAME,
} from '../constants/parameterDescriptions';
import {
    paramDetectName,
    paramDsName,
    paramWhere,
} from '../constants/parameterNames';
import { typeBoolean, typeDataSource } from '../constants/parameterTypes';
import { failure, success } from '../helpers/commandResult';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import { getDataConnection } from '../helpers/qRules.dataConnection.helpers';

const optionalParameters = [
    {
        name: paramDetectName,
        description: DESCRIPTION_DETECTNAME,
        type: typeBoolean,
    },
];
const requiredParameters = [
    {
        name: paramDsName,
        description: DESCRIPTION_SQL_DSNAME,
        type: typeDataSource,
    },
    {
        name: paramWhere,
        description: 'Where clause for SQL Command, e.g. WHERE Sales >= 12345',
    },
];
const modifySqlQueryUnsupportedConnectionTypeError =
    'ModifySQLQuery is only for use with SQL data connections';
const modifySqlQueryError = 'ModifySqlQuery error: {0}';
const description =
    'This command will allow you to add a WHERE clause to an existing SQL data connection. It will execute the SQL query after adding the WHERE clause.';

async function executeModifySqlQueryAsync(dc, where, detectName) {
    const origCmdText = dc.getCommandText();
    const newCmdText = `${origCmdText} ${where}`;
    const execOptions = {
        detectName,
    };

    try {
        dc.setCommandText(newCmdText);

        await dc.queryAsync(execOptions);

        return success();
    } catch (e) {
        return failure(String.format(modifySqlQueryError, e));
    } finally {
        dc.setCommandText(origCmdText);
    }
}

function executeAsync({ dataConnections, parameters }) {
    const dsName = getParamValue(parameters, paramDsName);
    const where = getParamValue(parameters, paramWhere);
    const detectName = getBoolParamValue(parameters, paramDetectName, false);
    const dc = getDataConnection(dataConnections, dsName);

    if (!dc.isAdoSupported()) {
        return failure(modifySqlQueryUnsupportedConnectionTypeError);
    }

    return executeModifySqlQueryAsync(dc, where, detectName);
}

const ModifySqlQuery = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default ModifySqlQuery;
